<template>
  <section class="container story04">
    <div class="wrap">
      <h2 class="story04--tit">Meet Our Brands</h2>
      <p class="story04--descript">
        ‘원료와 기능을 투명하게 공개’ 한다는 원칙으로 <br>글로벌 S&amp;P의 비전을
        공유하고 독보적인 품질로 <br>고객에게 신뢰받는 브랜드 지향점을 담고 있습니다.
      </p>
      <div>
        <div class="row">
          <div class="col-sm-6 story04--con">
            <h3 class="story04--subtit">BI</h3>
            <!-- <img
              :src="image.imageLink"
              class="story04--img pointer"
              alt="incellderm"
              @click="downloadFile"
            /> -->
            <div class="story04--bi pointer" @click="downloadFile"></div>
          </div>
          <div class="col-sm-6 story04--con">
            <h3 class="story04--subtit">Color</h3>
            <div class="story04--colorwrap">
              <div class="story04--colorbar"></div>
              <div class="story04--colorcode">
                <dl class="story04--code">
                  <dt>PANTONE</dt>
                  <dd>440 C</dd>
                  <dt>RGB</dt>
                  <dd>R57 G45 B43</dd>
                  <dt>CMYK</dt>
                  <dd>C58 M60 Y57 K68</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import downloadApi from '@/apis/download';

export default {
  name: 'Section4',
  data() {
    return {
      image: { 
        id: 'Incellderm', 
        imageLink: require('@/assets/images/brandstory/incellderm02.png'), 
        downloadLink: `${process.env.VUE_APP_STATIC_URL}/HP-Rimankorea/CI/incellderm.png` 
      },
    };
  },
  methods: {
    downloadFile() {
      downloadApi.downloadFile(this.image.downloadLink, this.image.downloadLink.substr(this.image.downloadLink.lastIndexOf('/') + 1));
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
